<template>
  <v-container fluid>
    <v-container fluid ref="content" id="editor">
      <v-layout justify-center>
        <h4 class="headline font-weight-black">
          {{
            data.header.sub_company ? data.header.sub_company.toUpperCase() : ""
          }}
        </h4>
      </v-layout>

      <v-layout justify-center>
        <h3>TRIP OPERATION REPORT</h3>
      </v-layout>

      <!-- presell's head table -->
      <table
        v-if="data.header.ticketing_type == 2"
        class="data-table mt-2"
        style="width: 100%;"
      >
        <tr>
          <th colspan="3" class="data-th font-weight-black">
            <p>EMPLOYEE NO.</p>
          </th>
          <th colspan="3" class="data-th font-weight-regular">
            <p>
              {{ data.header.cashier_no.toUpperCase() }}
            </p>
          </th>
          <th colspan="3" class="data-th font-weight-black">
            <p>DATE AND TIME OF TRIP</p>
          </th>
          <th colspan="3" class="data-th font-weight-regular">
            <p>
              {{ $dateFormat(data.header.trip_date, "MM/DD/YYYY hh:mm:ss A") }}
            </p>
          </th>
        </tr>
        <tr>
          <th colspan="3" class="data-th font-weight-black">
            <p>TELLER</p>
          </th>
          <th colspan="3" class="data-th font-weight-regular">
            <p>
              {{
                data.header.cashier_name
                  ? data.header.cashier_name.toUpperCase()
                  : "-"
              }}
            </p>
          </th>
          <th colspan="3" class="data-th font-weight-black">
            <p>DATE AND TIME REMIT</p>
          </th>
          <th colspan="3" class="data-th font-weight-regular">
            <p>
              {{
                $dateFormat(
                  data.header.remittance_date,
                  "MM/DD/YYYY hh:mm:ss A"
                )
              }}
            </p>
          </th>
        </tr>
        <tr>
          <th colspan="3" class="data-th font-weight-black">
            <p>TERMINAL</p>
          </th>
          <th colspan="3" class="data-th font-weight-regular">
            <p>
              {{
                data.header.terminal_name
                  ? data.header.terminal_name.toUpperCase()
                  : "-"
              }}
            </p>
          </th>
          <th colspan="3" class="data-th font-weight-black">
            <p>DATE AND TIME OF EOD</p>
          </th>
          <th colspan="3" class="data-th font-weight-regular">
            <p>{{ eodDate }}</p>
          </th>
        </tr>

        <tr>
          <th colspan="3" class="data-th font-weight-black">
            <p>
              CONTROL NO
            </p>
          </th>
          <th colspan="3" class="data-th font-weight-regular">
            <p>{{ data.header.control_no ? data.header.control_no : "-" }}</p>
          </th>
          <th colspan="3" class="data-th font-weight-black">
            <p>DEVICE SERIAL</p>
          </th>
          <th colspan="3" class="data-th font-weight-regular">
            <p>{{ data.header.device_serial }}</p>
          </th>
        </tr>

        <tr>
          <th colspan="6" class="data-th font-weight-black">
            <p>
              {{
                `CARD SALES: ${$amountInPeso(data.tick_issuance.card_sales)}`
              }}
            </p>
          </th>
          <th colspan="6" class="data-th font-weight-black">
            <p>
              {{
                `GROSS REVENUE: ${$amountInPeso(data.header.gross_collection)}`
              }}
            </p>
          </th>
        </tr>
      </table>

      <!-- standard head table -->
      <table v-else class="data-table mt-2" style="width: 100%;">
        <tr>
          <th colspan="4" class="data-th font-weight-black">
            <p>EMPLOYEE NO.</p>
          </th>
          <th colspan="5" class="data-th font-weight-regular">
            <p>
              {{
                data.header.driver_no
                  ? data.header.driver_no.toUpperCase()
                  : "-"
              }}
            </p>
          </th>
          <!-- <th colspan="2" class="data-th font-weight-black">
            <p>DRIVER</p>
          </th>
          <th colspan="2" class="data-th font-weight-regular">
            <p>
              {{
                data.header.driver_name
                  ? data.header.driver_name.toUpperCase()
                  : "-"
              }}
            </p>
          </th> -->
          <th colspan="4" class="data-th font-weight-black">
            <p>DATE AND TIME OF TRIP</p>
          </th>
          <th colspan="5" class="data-th font-weight-regular">
            <p>
              {{ $dateFormat(data.header.trip_date, "MM/DD/YYYY hh:mm:ss A") }}
            </p>
          </th>
        </tr>
        <tr>
          <th colspan="4" class="data-th font-weight-black">
            <p>EMPLOYEE NO.</p>
          </th>
          <th colspan="5" class="data-th font-weight-regular">
            <p
              v-if="
                setting.conductor_status == 0 &&
                  setting.backup_driver_status == 1
              "
            >
              {{
                data.trip_record.trip_rec.backup_driver_no
                  ? data.trip_record.trip_rec.backup_driver_no.toUpperCase()
                  : "-"
              }}
            </p>

            <p v-else>
              {{
                data.header.conductor_no
                  ? data.header.conductor_no.toUpperCase()
                  : "-"
              }}
            </p>
          </th>
          <!-- <th colspan="2" class="data-th font-weight-black">
            <p>
              {{
                `${
                  setting.conductor_status == 0 &&
                  setting.backup_driver_status == 1
                    ? "DRIVER 2"
                    : "CONDUCTOR"
                }`
              }}
            </p>
          </th> -->
          <!-- <th colspan="2" class="data-th font-weight-regular">
            <p
              v-if="
                setting.conductor_status == 0 &&
                  setting.backup_driver_status == 1
              "
            >
              {{
                data.trip_record.trip_rec.backup_driver_name
                  ? data.trip_record.trip_rec.backup_driver_name.toUpperCase()
                  : "-"
              }}
            </p>
            <p v-else>
              {{
                data.header.conductor_name
                  ? data.header.conductor_name.toUpperCase()
                  : "-"
              }}
            </p>
          </th> -->
          <th colspan="4" class="data-th font-weight-black">
            <p>DATE AND TIME REMIT</p>
          </th>
          <th colspan="5" class="data-th font-weight-regular">
            <p>
              {{
                $dateFormat(
                  data.header.remittance_date,
                  "MM/DD/YYYY hh:mm:ss A"
                )
              }}
            </p>
          </th>
        </tr>
        <tr>
          <th colspan="4" class="data-th font-weight-black">
            <p>STORE NAME</p>
          </th>
          <th colspan="5" class="data-th font-weight-regular">
            <p>
              {{
                data.header.vehicle_no
                  ? data.header.vehicle_no.toUpperCase()
                  : "-"
              }}
            </p>
          </th>
          <!-- <th colspan="2" class="data-th font-weight-black">
            <p>TERMINAL</p>
          </th>
          <th colspan="2" class="data-th font-weight-regular">
            <p>
              {{
                data.header.terminal_name
                  ? data.header.terminal_name.toUpperCase()
                  : "-"
              }}
            </p>
          </th> -->
          <th colspan="4" class="data-th font-weight-black">
            <p>DATE AND TIME OF EOD</p>
          </th>
          <th colspan="5" class="data-th font-weight-regular">
            <p>{{ eodDate }}</p>
          </th>
        </tr>
        <tr>
          <th colspan="3" class="data-th font-weight-black">
            <p>TERMINAL</p>
          </th>
          <th colspan="3" class="data-th font-weight-regular">
            <p>
              {{
                data.header.terminal_name
                  ? data.header.terminal_name.toUpperCase()
                  : "-"
              }}
            </p>
          </th>
          <th colspan="3" class="data-th font-weight-black">
            <p> CONTROL NO: </p>
          </th>
          <th colspan="3" class="data-th font-weight-regular">
            <p>
              {{
                // `${
                //   data.header.company_code === "DLTB"
                //     ? "CONTROL NO"
                //     : "CONTROL NO. "
                // }: ${data.header.control_no}`
                data.header.control_no ? data.header.control_no : "-"
              }}
            </p>
          </th>
          <!-- <th colspan="3" class="data-th font-weight-black">
            <p>
              {{
                data.header.company_code === "DLTB"
                ? "TOR NO:"+data.header.custom_control_no
                : ""
              }}
            </p>
          </th> -->
          <th colspan="3" class="data-th font-weight-black">
            <p>DEVICE SERIAL:</p>
          </th>
          <th colspan="3" class="data-th font-weight-regular">
            <p> {{ data.header.device_serial }} </p>
          </th>
        </tr>
      </table>

      <!-- Presell Ticket Issuance table -->
      <table
        class="data-table"
        v-if="data.header.ticketing_type == 2"
        style="width: 100%;"
      >
        <thead>
          <tr>
            <th
              class="data-th"
              :colspan="
                8 +
                  (data.tick_issuance.passenger_type_header
                    ? data.tick_issuance.passenger_type_header.length
                    : 1) +
                  (setting.baggage_status ? 2 : 0)
              "
              bgcolor="#E0E0E0"
            >
              <p>TICKET ISSUANCE</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" rowspan="2" colspan="4">
              <p>BRANCH</p>
            </th>
            <!-- <th class="data-th" colspan="6">TICKET NO.</th> -->
            <th class="data-th" rowspan="2" colspan="2">
              <p>TRANSACTION COUNT</p>
            </th>
            <th class="data-th" rowspan="2" colspan="3">
              <p>GROSS REVENUE</p>
            </th>
            <th
              v-if="setting.baggage_status"
              class="data-th"
              rowspan="2"
              colspan="2"
            >
              <p>NO. OF BAG</p>
            </th>
            <th
              class="data-th"
              style=" width: 5%; text-align:center"
              :colspan="
                0 +
                  (data.tick_issuance.passenger_type_header
                    ? data.tick_issuance.passenger_type_header.length
                    : 0)
              "
            >
              <p>PASSENGER TYPE</p>
            </th>
          </tr>
          <tr>
            <!-- <th class="data-th" colspan="3">
              <p>BEGINNING</p>
            </th>
            <th class="data-th" colspan="3">
              <p>ENDING</p>
            </th> -->
            <!-- Passenger Type Header -->
            <template
              v-if="
                data.tick_issuance.passenger_type_header
                  ? data.tick_issuance.passenger_type_header.length
                  : false
              "
            >
              <th
                v-for="(item, i) in data.tick_issuance.passenger_type_header"
                :key="i"
                class="data-th"
                colspan="1"
              >
                <p>{{ item.name ? item.name.toUpperCase() : "-" }}</p>
              </th>
            </template>
            <th v-else class="data-th" colspan="1">
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-if="
              data.tick_issuance.ticket_issuance
                ? data.tick_issuance.ticket_issuance.length
                : false
            "
          >
            <tr
              v-for="(item, i) in data.tick_issuance.ticket_issuance"
              :key="i"
            >
              <th class="data-th font-weight-regular" colspan="4">
                {{ item.route_name ? item.route_name.toUpperCase() : "-" }}
              </th>
              <!-- <th class="data-th font-weight-regular" colspan="3">
                {{ item.opening_ticket }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{ item.closing_ticket }}
              </th> -->
              <th class="data-th" colspan="2">
                <v-tooltip top>
                  <v-btn slot="activator" flat small @click="openDialog(item)">
                    <p class="font-weight-regular">
                      {{ item.passenger_count }}
                    </p>
                  </v-btn>
                  <span>View Passenger Tickets</span>
                </v-tooltip>
              </th>
              <th class="data-th font-weight-regular" colspan="2">
                <p class="right">{{ $amountInPeso(item.gross_revenue) }}</p>
              </th>
              <th v-if="setting.baggage_status" class="data-th" colspan="2">
                <v-tooltip top>
                  <v-btn
                    slot="activator"
                    flat
                    small
                    @click="openBaggageDialog(item)"
                  >
                    <p class="font-weight-regular">{{ item.baggage_count }}</p>
                  </v-btn>
                  <span>View Baggage Tickets</span>
                </v-tooltip>
              </th>
              <!-- Passenger Type Data -->
              <template
                v-if="
                  data.tick_issuance.passenger_type_header
                    ? data.tick_issuance.passenger_type_header.length
                    : false
                "
              >
                <th
                  v-for="(item2, e) in item.passenger_type_data"
                  :key="e"
                  class="data-th font-weight-regular"
                  colspan="1"
                >
                  {{ item2.count }}
                </th>
              </template>
              <th v-else class="data-th" colspan="10">
                <p class="font-weight-regular text-center">No Data</p>
              </th>
            </tr>

            <tr>
              <th class="data-th" colspan="4">
                <p class="right">TOTAL:</p>
              </th>

              <th class="data-th" colspan="2">
                {{ data.tick_issuance.ticket_issuance_total.passenger_count }}
              </th>
              <th class="data-th" colspan="2">
                <p class="right">
                  {{
                    $amountInPeso(
                      data.tick_issuance.ticket_issuance_total.gross_revenue
                    )
                  }}
                </p>
              </th>
              <th v-if="setting.baggage_status" class="data-th" colspan="2">
                {{ data.tick_issuance.ticket_issuance_total.baggage_count }}
              </th>
              <!-- Passenger Type Total -->
              <template
                v-if="
                  data.tick_issuance.passenger_type_header
                    ? data.tick_issuance.passenger_type_header.length
                    : false
                "
              >
                <th
                  v-for="(item, i) in data.tick_issuance.passenger_type_header"
                  :key="i"
                  class="data-th"
                  colspan="1"
                >
                  <p>{{ item.total_count }}</p>
                </th>
              </template>
              <th
                v-else
                class="data-th"
                :colspan="1 + (setting.baggage_status ? 2 : 0)"
              >
                <p class="font-weight-regular text-center">No Data</p>
              </th>
            </tr>
          </template>
          <tr v-else>
            <th
              class="data-th"
              :colspan="
                14 +
                  (data.tick_issuance.passenger_type_header
                    ? data.tick_issuance.passenger_type_header.length
                    : 1) +
                  (setting.baggage_status ? 2 : 0)
              "
            >
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table>

      <!-- standard Ticket Issuance table -->
      <table class="data-table" v-else style="width: 100%;">
        <thead>
          <tr>
            <th
              class="data-th"
              :colspan="
                14 +
                  (data.tick_issuance.passenger_type_header
                    ? data.tick_issuance.passenger_type_header.length
                    : 1) +
                  (setting.baggage_status ? 2 : 0)
              "
              bgcolor="#E0E0E0"
            >
              <p>TICKET ISSUANCE</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" rowspan="2" colspan="4">
              <p>BRANCH</p>
            </th>
            <th class="data-th" colspan="6">TICKET NO.</th>
            <th class="data-th" rowspan="2" colspan="2">
              <p>TRANSACTION COUNT</p>
            </th>
            <th class="data-th" rowspan="2" colspan="3">
              <p>GROSS REVENUE</p>
            </th>
            <th
              v-if="setting.baggage_status"
              class="data-th"
              rowspan="2"
              colspan="2"
            >
              <p>NO. OF BAG</p>
            </th>
            <!-- <th
              class="data-th"
              style=" width: 5%; text-align:center"
              :colspan="
                0 +
                  (data.tick_issuance.passenger_type_header
                    ? data.tick_issuance.passenger_type_header.length
                    : 0)
              "
            > -->
              <!-- <p>PASSENGER TYPE</p> -->
            <!-- </th> -->
          </tr>
          <tr>
            <th class="data-th" colspan="3">
              <p>BEGINNING</p>
            </th>
            <th class="data-th" colspan="3">
              <p>ENDING</p>
            </th>
            <!-- Passenger Type Header -->
            <!-- <template
              v-if="
                data.tick_issuance.passenger_type_header
                  ? data.tick_issuance.passenger_type_header.length
                  : false
              "
            >
              <th
                v-for="(item, i) in data.tick_issuance.passenger_type_header"
                :key="i"
                class="data-th"
                colspan="1"
              >
                <p>{{ item.name ? item.name.toUpperCase() : "-" }}</p>
              </th>
            </template>
            <th v-else class="data-th" colspan="1">
              <p class="font-weight-regular text-center">No Data</p>
            </th> -->
          </tr>
        </thead>
        <tbody>
          <template
            v-if="
              data.tick_issuance.ticket_issuance
                ? data.tick_issuance.ticket_issuance.length
                : false
            "
          >
            <tr
              v-for="(item, i) in data.tick_issuance.ticket_issuance"
              :key="i"
            >
              <th
                class="data-th font-weight-regular"
                colspan="4"
                v-bind:style="
                  item.route_name.length > 28
                    ? 'font-size: 10px;'
                    : 'font-size: 12px'
                "
              >
                {{ item.route_name ? item.route_name.toUpperCase() : "-" }}
              </th>
              <th
                class="data-th font-weight-regular"
                style="overflow-wrap: break-word"
                colspan="3"
              >
                {{ item.opening_ticket }}
              </th>
              <th
                class="data-th font-weight-regular"
                style="overflow-wrap: break-word"
                colspan="3"
              >
                {{ item.closing_ticket }}
              </th>
              <th class="data-th" colspan="2">
                <v-tooltip top>
                  <v-btn slot="activator" flat small @click="openDialog(item)">
                    <p class="font-weight-regular">
                      {{ item.passenger_count }}
                    </p>
                  </v-btn>
                  <span>View Passenger Tickets</span>
                </v-tooltip>
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                <p class="center">{{ $amountInPeso(item.gross_revenue) }}</p>
              </th>
              <th v-if="setting.baggage_status" class="data-th" colspan="2">
                <v-tooltip top>
                  <v-btn
                    slot="activator"
                    flat
                    small
                    @click="openBaggageDialog(item)"
                  >
                    <p class="font-weight-regular">{{ item.baggage_count }}</p>
                  </v-btn>
                  <span>View Baggage Tickets</span>
                </v-tooltip>
              </th>
              <!-- Passenger Type Data -->
              <!-- <template
                v-if="
                  data.tick_issuance.passenger_type_header
                    ? data.tick_issuance.passenger_type_header.length
                    : false
                "
              >
                <th
                  v-for="(item2, e) in item.passenger_type_data"
                  :key="e"
                  class="data-th font-weight-regular"
                  colspan="1"
                >
                  {{ item2.count }}
                </th>
              </template>
              <th v-else class="data-th" colspan="10">
                <p class="font-weight-regular text-center">No Data</p>
              </th> -->
            </tr>

            <tr>
              <th class="data-th" colspan="10">
                <p class="right">TOTAL:</p>
              </th>

              <th class="data-th" colspan="2">
                {{ data.tick_issuance.ticket_issuance_total.passenger_count }}
              </th>
              <th class="data-th" colspan="3">
                <p class="center">
                  {{
                    $amountInPeso(
                      data.tick_issuance.ticket_issuance_total.gross_revenue
                    )
                  }}
                </p>
              </th>
              <th v-if="setting.baggage_status" class="data-th" colspan="2">
                {{ data.tick_issuance.ticket_issuance_total.baggage_count }}
              </th>
              <!-- Passenger Type Total -->
              <!-- <template
                v-if="
                  data.tick_issuance.passenger_type_header
                    ? data.tick_issuance.passenger_type_header.length
                    : false
                "
              >
                <th
                  v-for="(item, i) in data.tick_issuance.passenger_type_header"
                  :key="i"
                  class="data-th"
                  colspan="1"
                >
                  <p>{{ item.total_count }}</p>
                </th>
              </template>
              <th
                v-else
                class="data-th"
                :colspan="1 + (setting.baggage_status ? 2 : 0)"
              >
                <p class="font-weight-regular text-center">No Data</p>
              </th> -->
            </tr>
          </template>
          <tr v-else>
            <th
              class="data-th"
              :colspan="
                14 +
                  (data.tick_issuance.passenger_type_header
                    ? data.tick_issuance.passenger_type_header.length
                    : 1) +
                  (setting.baggage_status ? 2 : 0)
              "
            >
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table>

      <table
        v-if="data.header.ticketing_type != 2"
        class="data-table"
        style="width: 100%;"
      >
        <thead>
          <tr>
            <th class="data-th" colspan="18" bgcolor="#E0E0E0">
              <p>TRIP RECORD</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" colspan="9">DEPARTED AT</th>
            <th class="data-th" colspan="9">ARRIVED AT</th>
          </tr>
          <tr>
            <th class="data-th" colspan="3">
              <p>DATE/TIME</p>
            </th>
            <th class="data-th" colspan="3">
              <p>PLACE</p>
            </th>
            <th class="data-th" colspan="3">
              <p>NAME</p>
            </th>
            <th class="data-th" colspan="3">
              <p>DATE/TIME</p>
            </th>
            <th class="data-th" colspan="3">
              <p>PLACE</p>
            </th>
            <th class="data-th" colspan="3">
              <p>NAME</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-if="
              data.trip_record.trip_rec
                ? data.trip_record.trip_rec.length
                : false
            "
          >
            <tr v-for="(item, i) in data.trip_record.trip_rec" :key="i">
              <th class="data-th font-weight-regular" colspan="3">
                {{ $dateFormat(item.dispatched_date, "MM/DD/YYYY hh:mm:ss A") }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{
                  item.dispatched_place
                    ? item.dispatched_place.toUpperCase()
                    : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{
                  item.dispatched_by ? item.dispatched_by.toUpperCase() : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{
                  $dateFormat(item.arrival_datetime, "MM/DD/YYYY hh:mm:ss A")
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{
                  item.arrival_place ? item.arrival_place.toUpperCase() : "-"
                }}
              </th>
              <th class="data-th font-weight-regular" colspan="3">
                {{ item.arrival_by ? item.arrival_by.toUpperCase() : "-" }}
              </th>
            </tr>
          </template>
          <tr v-else>
            <th class="data-th" colspan="18">
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table>

      <!-- <table
        v-if="data.header.ticketing_type != 2"
        class="data-table"
        style="width: 100%;"
      >
        <thead>
          <tr>
            <th class="data-th" colspan="42" bgcolor="#E0E0E0">
              <p>INSPECTIONS</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" colspan="5">
              <p>DATE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>TIME</p>
            </th>
            <th class="data-th" colspan="5">
              <p>KM ON</p>
            </th>
            <th class="data-th" colspan="6">
              <p>PLACE</p>
            </th>
            <th class="data-th" colspan="7">
              <p>BOUND</p>
            </th>
            <th class="data-th" colspan="7">
              <p>HEADCOUNT</p>
            </th>
            <th class="data-th" colspan="7">
              <p>NAME</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="data.inspections ? data.inspections.length : false">
            <tr v-for="(item, i) in data.inspections" :key="i">
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.date ? $dateFormat(item.date, "MM/DD/YYYY") : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.date ? $dateFormat(item.date, "hh:mm:ss A") : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ item.km_on == null ? "-" : item.km_on }}
              </th>
              <th class="data-th font-weight-regular" colspan="6">
                {{ item.place ? item.place.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.bound ? item.bound.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.head_count === null ? "-" : item.head_count }}
              </th>
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.name ? item.name.toUpperCase() : "-" }}
              </th>
            </tr>
          </template>

          <tr v-else>
            <th class="data-th" colspan="42">
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table> -->

      <table
        v-if="data.header.ticketing_type != 2"
        class="data-table"
        style="width: 100%;"
      >
        <thead>
          <tr>
            <th class="data-th" colspan="36" bgcolor="#E0E0E0">
              <p>CASH DEPOSIT</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" colspan="5">
              <p>DATE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>TIME</p>
            </th>
            <th class="data-th" colspan="6">
              <p>TERMINAL</p>
            </th>
            <th class="data-th" colspan="6">
              <p>AMOUNT</p>
            </th>
            <th class="data-th" colspan="7">
              <p>AMOUNT IN WORDS</p>
            </th>
            <th class="data-th" colspan="7">
              <p>CASHIER'S NAME</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="data.cash_deposit ? data.cash_deposit.length : false">
            <tr v-for="(item, i) in data.cash_deposit" :key="i">
              <th class="data-th font-weight-regular" colspan="5">
                {{ $dateFormat(item.date, "MM/DD/YYYY") }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ $dateFormat(item.date, "hh:mm:ss A") }}
              </th>
              <th class="data-th font-weight-regular" colspan="6">
                {{ item.terminal ? item.terminal.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="6">
                {{ $amountInPeso(item.amount) }}
              </th>
              <th class="data-th font-weight-regular" colspan="7">
                {{ $amountToWord(item.amount).toUpperCase() }}
              </th>
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.name ? item.name.toUpperCase() : "-" }}
              </th>
            </tr>
          </template>

          <tr v-else>
            <th class="data-th" colspan="36">
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table>
      <!--new-->
      <table
        v-if="data.header.ticketing_type != 2"
        class="data-table"
        style="width: 100%;"
      >
        <thead>
          <tr>
            <th class="data-th" colspan="36" bgcolor="#E0E0E0">
              <p>CASH ADVANCE</p>
            </th>
          </tr>
          <tr>
            <th class="data-th" colspan="5">
              <p>DATE</p>
            </th>
            <th class="data-th" colspan="5">
              <p>TIME</p>
            </th>
            <th class="data-th" colspan="6">
              <p>TERMINAL</p>
            </th>
            <th class="data-th" colspan="6">
              <p>AMOUNT</p>
            </th>
            <th class="data-th" colspan="7">
              <p>AMOUNT IN WORDS</p>
            </th>
            <th class="data-th" colspan="7">
              <p>CASHIER'S NAME</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <template
            v-if="data.cash_advances ? data.cash_advances.length : false"
          >
            <tr v-for="(item, i) in data.cash_advances" :key="i">
              <th class="data-th font-weight-regular" colspan="5">
                {{ $dateFormat(item.date, "MM/DD/YYYY") }}
              </th>
              <th class="data-th font-weight-regular" colspan="5">
                {{ $dateFormat(item.date, "hh:mm:ss A") }}
              </th>
              <th class="data-th font-weight-regular" colspan="6">
                {{ item.terminal ? item.terminal.toUpperCase() : "-" }}
              </th>
              <th class="data-th font-weight-regular" colspan="6">
                {{ $amountInPeso(item.amount) }}
              </th>
              <th class="data-th font-weight-regular" colspan="7">
                {{ $amountToWord(item.amount).toUpperCase() }}
              </th>
              <th class="data-th font-weight-regular" colspan="7">
                {{ item.name ? item.name.toUpperCase() : "-" }}
              </th>
            </tr>
          </template>

          <tr v-else>
            <th class="data-th" colspan="36">
              <p class="font-weight-regular text-center">No Data</p>
            </th>
          </tr>
        </tbody>
      </table>
      <!-- new -->
      <table
        v-if="data.header.ticketing_type != 2"
        class="data-table"
        style="width: 100%;"
      >
        <tr>
          <th class="data-th" colspan="36" bgcolor="#E0E0E0">
            <p>COLLECTIONS AND EXPENSES COMPUTATIONS</p>
          </th>
        </tr>
        <tr>
          <th
            class="data-th"
            colspan="18"
            style="padding: 0; border-top: 2px solid black;"
          >
            <table class="data-table-2" style="width: 100%;">
              <!-- <tr>
                <th colspan="36" class="data-th"></th>
              </tr> -->
              <!-- <tr>
                <th colspan="18" class="data-th">
                  <p>FUEL LOAD</p>
                </th>
                <th colspan="18" class="data-th">
                  <p>GASMAN</p>
                </th>
              </tr>
              <tr>
                <th colspan="5" class="data-th">
                  <p>DATE</p>
                </th>
                <th colspan="4" class="data-th">
                  <p>TIME</p>
                </th>
                <th colspan="9" class="data-th">
                  <p>STATION</p>
                </th>
                <th colspan="9" class="data-th">
                  <p>LITERS</p>
                </th>
                <th colspan="9" class="data-th">
                  <p>NAME</p>
                </th>
              </tr> -->
              <!-- <template v-if="data.diesels ? data.diesels.length : false">
                <tr v-for="(item, i) in data.diesels" :key="i">
                  <th colspan="5" class="data-th font-weight-regular">
                    {{ $dateFormat(item.date, "MM/DD/YYYY") }}
                  </th>
                  <th colspan="4" class="data-th font-weight-regular">
                    {{ $dateFormat(item.date, "hh:mm A") }}
                  </th>

                  <th colspan="9" class="data-th font-weight-regular">
                    {{ item.station }}
                  </th>
                  <th colspan="9" class="data-th font-weight-regular">
                    {{ item.liters }}
                  </th>
                  <th colspan="9" class="data-th font-weight-regular">
                    {{ item.name ? item.name.toUpperCase() : "--" }}
                  </th>
                </tr>
              </template>
              <tr v-else>
                <th class="data-th" colspan="36">
                  <p class="font-weight-regular text-center">No Data</p>
                </th>
              </tr> -->
              <tr>
                <th colspan="36" class="data-th-2">
                  <v-container>
                    <v-layout v-for="(item, i) in data.expenses" :key="i">
                      <v-flex md6>
                        <span>{{ item.name }}</span>
                        <br />
                      </v-flex>
                      <v-flex md6>
                        <div
                          style="border-bottom: 1px solid black; width: 200px; text-align: right;"
                        >
                          {{ $amountInPeso(item.amount) }}
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout class="mt-5">
                      <v-flex md3>
                        <span>TOTAL EXPENSES</span>
                        <br />
                        <br />
                        <br />
                        <span>CASH SALES</span>
                        <br />
                        <span>CARD SALES</span>
                        <br />
                        <span>PRE-SELL SALES</span>
                      </v-flex>
                      <v-flex md6>
                        <div
                          style="border-bottom: 1px solid black; width: 200px; text-align: right;"
                        >
                          {{ $amountInPeso(data.header.total_expense) }}
                        </div>
                        <div
                          style="border-bottom: 1px solid black; width: 200px; margin-top: 30px; text-align: right;"
                        >
                          {{ $amountInPeso(data.tick_issuance.cash_sales) }}
                        </div>
                        <div
                          style="border-bottom: 1px solid black; width: 200px; text-align: right;"
                        >
                          {{ $amountInPeso(data.tick_issuance.card_sales) }}
                        </div>
                        <div
                          style="border-bottom: 1px solid black; width: 200px; text-align: right;"
                        >
                          {{ $amountInPeso(data.tick_issuance.presell_sales) }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </th>
              </tr>
            </table>
          </th>
          <th
            class="data-th-2"
            colspan="18"
            style="height: 0; border-top: 2px solid black;"
          >
            <v-container style="height: 100%;">
              <div v-if="data.hasOwnProperty('sp_contents')">
              <v-layout
                v-for="(item, i) in data.sp_contents.special_contents"
                :key="i"
              >
                <v-flex md6>
                  <span>{{ item.name.toUpperCase() }}</span>
                  <br /><br />
                </v-flex>
                <v-flex md6>
                  <div
                    style="border-bottom: 1px solid black; width: 200px; text-align: right;"
                  >
                    {{ $amountInPeso(item.amount) }}
                  </div>
                </v-flex>
              </v-layout>
              </div>
              <br />
              <v-layout style="height: 100%;">
                <v-flex style="height: 100%;" md6>
                  <span
                    style="display: inline-block; margin-top: 5px; margin-bottom: 0px;"
                    >GROSS REVENUE</span
                  >
                  <br />
                  <br />
                  <br />
                  <span
                    style="display: inline-block; margin-top: 11px; margin-bottom: 0px;"
                    >LESS: CANCELLED SALES</span
                  >
                  <br />
                  <br />
                  <span
                    style="display: inline-block; margin-top: 11px; margin-bottom: 0px;"
                    >TOTAL EXPENSES</span
                  >
                  <br />
                  <br />
                  <span
                    style="display: inline-block; margin-top: 2.5px; margin-bottom: 0px;"
                    >NET REVENUE</span
                  >
                  <br />
                  <br />
                  <span
                    style="display: inline-block; margin-top: 2px; margin-bottom: 0px;"
                    >TOTAL PARTIAL</span
                  >
                  <br />
                  <br />
                  <span
                    style="display: inline-block; margin-top: 2px; margin-bottom: 0px;"
                    >TOTAL CASH ADVANCE</span
                  >
                  <br />
                  <br />
                  <span
                    style="display: inline-block; margin-top: 2px; margin-bottom: 0px;"
                    >CARD SALES</span
                  >
                  <br />
                  <br />
                  <span
                    style="display: inline-block; margin-top: 4.5px; margin-bottom: 0px;"
                    >{{
                      data.company_code === "DLTB"
                        ? "FINAL REMITTANCE"
                        : "FINAL CASH"
                    }}</span
                  >
                  <br />
                  <br />
                  <span
                    style="display: inline-block; margin-top: 2px; margin-bottom: 0px;"
                    >{{
                      data.company_code === "DLTB"
                        ? "FINAL CASH REMITTED"
                        : "CASH RECEIVED"
                    }}</span
                  >
                  <br />
                  <br />
                  <span
                    style="display: inline-block; margin-top: 1px; margin-bottom: 0px;"
                    >OVER/(SHORT)</span
                  >
                  <br />
                  <br />
                  <br />
                  <v-layout
                    v-if="
                      data.header.coding && data.header.company_code === 'DLTB'
                    "
                  >
                    <v-flex md4>
                      <span>CODING:</span>
                    </v-flex>
                    <v-flex md4>
                      <div
                        style="border-bottom: 1px solid black; width: 100px; text-align: center;"
                      >
                        {{ data.header.coding.toUpperCase() }}
                      </div>
                    </v-flex>
                  </v-layout>

                  <br />
                  <br />
                  <br />
                  <span>REMARKS</span>
                  <br />
                  <br />
                  <br />
                </v-flex>
                <v-flex style="height: 100%;" md6>
                  <div
                    style="border-bottom: 1px solid black; width: 200px; text-align: right;"
                  >
                    {{ $amountInPeso(data.header.gross_collection) }}
                  </div>
                  <div
                    style="border-bottom: 1px solid black; width: 200px; margin-top: 45px; text-align: right;"
                  >
                    {{ $amountInPeso(data.header.total_cancel_amount) }}
                  </div>
                  <div
                    style="border-bottom: 1px solid black; width: 200px; margin-top: 26px; text-align: right;"
                  >
                    {{ $amountInPeso(data.header.total_expense) }}
                  </div>
                  <div
                    style="border-bottom: 1px solid black; width: 200px; margin-top: 19px; text-align: right;"
                  >
                    {{
                      data.header.company_code === "DLTB"
                        ? $amountInPeso(data.sp_contents.net_remittance)
                        : $amountInPeso(data.header.net_remittance)
                    }}
                  </div>
                  <div
                    style="border-bottom: 1px solid black; width: 200px; margin-top: 18px; text-align: right;"
                  >
                    {{ $amountInPeso(data.header.total_partial) }}
                  </div>
                  <div
                    style="border-bottom: 1px solid black; width: 200px; margin-top: 18px; text-align: right;"
                  >
                    {{ $amountInPeso(data.cash_advances.total_cash_advance) }}
                  </div>
                  <div
                    style="border-bottom: 1px solid black; width: 200px; margin-top: 18px; text-align: right;"
                  >
                    {{ $amountInPeso(data.tick_issuance.card_sales) }}
                  </div>
                  <div
                    style="border-bottom: 1px solid black; width: 200px; margin-top: 18px; text-align: right;"
                  >
                    {{
                      data.header.company_code === "DLTB"
                        ? $amountInPeso(data.sp_contents.final_cash)
                        : $amountInPeso(data.header.final_cash)
                    }}
                  </div>
                  <div
                    style="border-bottom: 1px solid black; width: 200px; margin-top: 18px; text-align: right;"
                  >
                    {{ $amountInPeso(data.header.cash_received) }}
                  </div>
                  <div
                    style="border-bottom: 1px solid black; width: 200px; margin-top: 18px; text-align: right;"
                  >
                    {{
                      data.header.company_code === "DLTB"
                        ? $amountInPeso(data.sp_contents.short_over)
                        : $amountInPeso(data.header.short_over)
                    }}
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </th>
        </tr>
      </table>
    </v-container>
    <ticket-details-dialog
      :dataTicket="dataTicket"
      :data="trip"
      :route="route"
      ref="ticket"
      :dialog_type="dialog_type"
      :isBaggage="isBaggage"
      :loading="loading"
    ></ticket-details-dialog>
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";
import TicketDetailsDialog from "@/components/TicketDetailDialog";
export default {
  components: {
    TicketDetailsDialog,
  },
  props: {
    data: Object,
    eodDate: String,
    setting: Object,
  },
  data() {
    return {
      trip: {},
      dataTicket: [],
      dialog_type: "",
      route: "",
      special_contents: [],
      isBaggage: false,
      loading: false,
      queryParams: {
        dispatch_sync_id: null,
        route_id: null,
        remittance_id: null,
      },
    };
  },
  methods: {
    async openDialog(id) {
      this.dataTicket = [];
      this.trip = {};
      this.dialog_type = "";

      this.queryParams.dispatch_sync_id = id.dispatch_sync_id;
      this.queryParams.route_id = id.route_id;
      this.queryParams.remittance_id = id.remittance_id;
      this.loading = true;
      try {
        await this.$refs.ticket.openDialog();
        this.trip = this.data;
        this.route = this.data.tick_issuance.ticket_issuance[0].route_name;
        const response = (await Services.getEndOfDayTickets(this.queryParams))
          .data;

        console.log(response);

        this.dialog_type = await response.dialog_type;
        const dataTicket = await response.data;
        this.dataTicket = await dataTicket;
        this.loading = false;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
        this.loading = false;
      }
      return this.trip;
    },
    async openBaggageDialog(id) {
      this.dataTicket = [];
      this.trip = {};
      this.dialog_type = "baggage";
      this.loading = true;
      try {
        this.trip = this.data;
        this.route = this.data.tick_issuance.ticket_issuance[0].route_name;
        await this.$refs.ticket.openDialog();
        const response = (
          await Services.getEndOfDayBaggages(id.dispatch_sync_id)
        ).data;

        this.dialog_type = await response.dialog_type;
        this.dataTicket = response.data;

        if (response)
          this.isBaggage = response.data.some(
            (b) =>
              b.passenger_type !== null && b.passenger_type.includes("escorted")
          );
        this.loading = false;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
        this.loading = false;
      }
      return this.trip;
    },
    sortPassenger(data) {
      let sorted = [];

      sorted = data.sort((a, b) =>
        a.index > b.index ? 1 : b.index > a.index ? -1 : 0
      );

      return sorted;
    },
  },
};
</script>

<style scoped>
p {
  margin: auto;
  word-break: break-all;
  word-wrap: break-word;
}
.data-table {
  border: 3px solid;
  border-collapse: collapse;
  width: 100%;
  margin-bottom: 20px;
  table-layout: fixed;
}
.data-table-2 {
  border-collapse: collapse;
  width: 100%;
}
.data-th {
  text-align: center;
  font-size: 12px;
  border: 1px solid black;
  padding: 10px;
}

.data-th-2 {
  font-size: 12px;
  border: 1px solid black;
  padding: 10px;
  text-align: left;
}
</style>
